import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { HR_PRIVACY } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function HRPrivacy() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'HR Privacy Policy',
          item_name: 'HR Privacy Policy',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="HR Privacy Policy" />

      <ServiceSection data={HR_PRIVACY} />
      <PriceSection serviceName="HR_PRIVACY" />
      <WhatYouGet hideDecor primaryColor={HR_PRIVACY.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(HRPrivacy))
